export default __webpack_public_path__ + "static/media/rgp_pvh_nca_akmolinsk_region.daea4a92.png";